import s1Texture from "./img/texture-season-1.jpg";
import s2Texture from "./img/texture-season-2.jpg";
import s3Texture from "./img/texture-season-3.jpg";
import s4Texture from "./img/texture-season-4.jpg";
import s5Texture from "./img/texture-season-5.jpg";
import s6Texture from "./img/texture-season-6.jpg";
import s7Texture from "./img/texture-season-7.jpg";
import s8Texture from "./img/texture-season-8.jpg";
import s9Texture from "./img/texture-season-9.jpg";
import s10Texture from "./img/texture-season-10.jpg";
import s11Texture from "./img/texture-season-11.jpg";
import s12Texture from "./img/texture-season-12.jpg";
import s13Texture from "./img/texture-season-13.jpg";

export const COLORS = {
  // RED: "#da292a",
  RED: "#c62828",
  TWITCH: "#6441a5",
  MONEY: "#168118",
  MISC: "#666",
  HEIRLOOM: "#FF4500",
  SEASON_QUESTS: "#BD8418",
  SEASON_QUEST_6: "#46D2BF",
  SEASON_QUEST_7: "#156260",
  SEASON_QUEST_8: "#F99F3E",
  SEASON_QUEST_9: "#FE9F3E",
  SEASON_QUEST_10: "#065B55",
  SEASON_QUEST_11: "#F8ACA8",
  SEASON_QUEST_12: "#E3E02F",
  LTM: {
    ANNIVERSARY2: "#340100",
    SEASON9: "#883F5F",
    ARENAS_FLASH: "#666666",
    MONSTERS_WITHIN: "#202020",
  },

  COMMON: "#a8a8a8",
  RARE: "#51a8d6",
  EPIC: "#b237c8",
  LEGENDARY: "#cead21",
};

export const RARITIES = {
  BASE: "inherit",
  COMMON: "#a8a8a8",
  RARE: "#51a8d6",
  EPIC: "#b237c8",
  LEGENDARY: "#cead21",
  HEIRLOOM: "#ff4e1d",
};

// QUEST parameter:
// - [String] = Quest name
// - "treasurePacks" = A basic treasure pack season
export const SEASONS = Object.freeze({
  PRE: {
    NAME: "Preseason",
    COLOR: "#787878",
  },
  ONE: {
    NAME: "Wild Frontier",
    COLOR: "#741615",
    TEXTURE: s1Texture,
    LIGHT_BADGE: true,
    LIGHT_TITLE: true,
  },
  TWO: {
    NAME: "Battle Charge",
    COLOR: "#1C50B3",
    TEXTURE: s2Texture,
    LIGHT_BADGE: true,
    LIGHT_TITLE: true,
  },
  THREE: {
    NAME: "Meltdown",
    COLOR: "#C9DDE7",
    TEXTURE: s3Texture,
  },
  FOUR: {
    NAME: "Assimilation",
    COLOR: "#262626",
    TEXTURE: s4Texture,
    LIGHT_BADGE: true,
    LIGHT_TITLE: true,
  },
  FIVE: {
    NAME: "Fortune's Favor",
    COLOR: "#F2C879",
    TEXTURE: s5Texture,
    QUEST: "The Broken Ghost",
    QUEST_MAX: 45,
    QUEST_COLOR: COLORS.SEASON_QUESTS,
  },
  SIX: {
    NAME: "Boosted",
    COLOR: "#E834A8",
    TEXTURE: s6Texture,
    QUEST: "The First Ship",
    QUEST_MAX: 43,
    QUEST_COLOR: COLORS.SEASON_QUEST_6,
  },
  SEVEN: {
    NAME: "Ascension",
    COLOR: "#00B9C0",
    TEXTURE: s7Texture,
    QUEST: "Family Portrait",
    QUEST_MAX: 57,
    QUEST_COLOR: COLORS.SEASON_QUEST_7,
    QUEST_LIGHT_TITLE: true,
  },
  EIGHT: {
    NAME: "Mayhem",
    COLOR: "#EB4C21",
    TEXTURE: s8Texture,
    QUEST: "Armageddon",
    QUEST_MAX: 60,
    QUEST_COLOR: COLORS.SEASON_QUEST_8,
  },
  NINE: {
    NAME: "Legacy",
    COLOR: "#7300B8",
    TEXTURE: s9Texture,
    QUEST: "The Legacy Antigen",
    QUEST_MAX: 60,
    QUEST_COLOR: COLORS.SEASON_QUEST_9,
    LIGHT_BADGE: true,
    LIGHT_TITLE: true,
  },
  TEN: {
    NAME: "Emergence",
    COLOR: "#1BB4AC",
    TEXTURE: s10Texture,
    QUEST: "treasurePacks",
    QUEST_MAX: 60,
    QUEST_COLOR: COLORS.SEASON_QUEST_10,
    LIGHT_TITLE: true,
    QUEST_LIGHT_TITLE: true,
  },
  ELEVEN: {
    NAME: "Escape",
    COLOR: "#D95964",
    COLOR2: "#F2F2F2",
    TEXTURE: s11Texture,
    QUEST: "treasurePacks",
    QUEST_MAX: 45,
    QUEST_COLOR: COLORS.SEASON_QUEST_11,
    LIGHT_BADGE: true,
    LIGHT_TITLE: true,
    END_DATE: "2022-02-08",
  },
  TWELVE: {
    NAME: "Definance",
    COLOR: "#FCFA32",
    COLOR2: "#040301",
    TEXTURE: s12Texture,
    QUEST: "treasurePacks",
    QUEST_MAX: 45,
    QUEST_COLOR: COLORS.SEASON_QUEST_12,
    END_DATE: "2022-05-09",
  },
  THIRTEEN: {
    NAME: "Saviors",
    COLOR: "#554B62",
    COLOR2: "#554B62",
    TEXTURE: s13Texture,
    QUEST: "treasurePacks",
    QUEST_MAX: 45,
    QUEST_COLOR: "#333A91",
    LIGHT_TITLE: true,
    LIGHT_BADGE: true,
    QUEST_LIGHT_TITLE: true,
    QUEST_LIGHT_BADGE: true,
    END_DATE: "2022-08-08",
  },
  // SEASON+
});
export const SEASONS_ORDERED = Object.freeze([
  SEASONS.PRE,
  SEASONS.ONE,
  SEASONS.TWO,
  SEASONS.THREE,
  SEASONS.FOUR,
  SEASONS.FIVE,
  SEASONS.SIX,
  SEASONS.SEVEN,
  SEASONS.EIGHT,
  SEASONS.NINE,
  SEASONS.TEN,
  SEASONS.ELEVEN,
  SEASONS.TWELVE,
  SEASONS.THIRTEEN,
  // SEASON+
]);

export const BATTLEPASSES = Object.freeze({
  ONE: {
    FREE: [2, 12, 24, 34, 46],
    PREMIUM: [26, 43, 53, 73, 83, 86, 93],
  },
  TWO: {
    FREE: [12, 14, 16, 18, 20],
    PREMIUM: [5, 12, 22, 32, 50, 82, 92],
  },
  THREE: {
    FREE: [17, 21, 25, 29, 33],
    PREMIUM: [4, 6, 8, 16, 40, 48, 77],
  },
  FOUR: {
    FREE: [15, 19, 23, 27, 31],
    PREMIUM: [3, 5, 9, 22, 60, 69, 89],
  },
  FIVE: {
    FREE: [3, 7, 11, 17, 25, 32, 45],
    PREMIUM: [2, 5, 26, 56, 81, 88, 97],
  },
  SIX: {
    FREE: [5, 8, 11, 17, 23, 29, 45],
    PREMIUM: [2, 5, 7, 72, 80, 88, 97],
  },
  SEVEN: {
    FREE: [6, 9, 12, 18, 24, 30, 37, 45],
    PREMIUM: [2, 5, 16, 32, 40, 80, 97],
  },
  EIGHT: {
    FREE: [5, 13, 21, 29, 37, 45, 61],
    PREMIUM: [2, 5, 32, 39, 69, 97, 98],
  },
  NINE: {
    FREE: [13, 21, 29, 33, 37, 61, 77],
    PREMIUM: [2, 5, 40, 44, 57, 69, 97, 98],
  },
  TEN: {
    FREE: [13, 21, 28, 37, 46, 72, 78],
    PREMIUM: [3, 7, 17, 35, 65, 92, 99],
  },
  ELEVEN: {
    FREE: [13, 21, 29, 37, 68, 86, 94],
    PREMIUM: [3, 17, 35, 61, 76, 77, 98],
  },
  TWELVE: {
    FREE: [7, 19, 33, 45, 73, 81, 97],
    PREMIUM: [3, 63, 71, 78, 83, 86, 94],
  },
  THIRTEEN: {
    FREE: [11, 27, 35, 43, 51, 75, 97],
    PREMIUM: [3, 12, 36, 67, 78, 86, 94],
  },
  // SEASON+
});
export const BATTLEPASSES_ORDERED = Object.freeze([
  null,
  BATTLEPASSES.ONE,
  BATTLEPASSES.TWO,
  BATTLEPASSES.THREE,
  BATTLEPASSES.FOUR,
  BATTLEPASSES.FIVE,
  BATTLEPASSES.SIX,
  BATTLEPASSES.SEVEN,
  BATTLEPASSES.EIGHT,
  BATTLEPASSES.NINE,
  BATTLEPASSES.TEN,
  BATTLEPASSES.ELEVEN,
  BATTLEPASSES.TWELVE,
  BATTLEPASSES.THIRTEEN,
  // SEASON+
]);

export const LTMS = Object.freeze([
  null, // 0
  null, // 1
  null, // 2
  null, // 3
  null, // 4
  null, // 5
  null, // 6
  null, // 7
  [
    {
      name: "2nd Anniversary Event",
      available: 10,
      helpText: "Total number of Apex Packs received out of the 10 available",
      bgColor: COLORS.LTM.ANNIVERSARY2,
      darkBadge: true,
    },
  ], // 8
  [
    {
      name: "Thrillseekers Event",
      available: 4,
      helpText: "Total number of Apex Packs received out of the 4 available",
      bgColor: COLORS.LTM.SEASON9,
    },
  ], // 9
  [
    {
      name: "Arenas Flash Event",
      available: 10,
      helpText:
        "Five Arenas Flash Events over Seasons 9 + 10, two packs each for a total of 10 Apex Packs total",
      bgColor: COLORS.LTM.ARENAS_FLASH,
      darkBadge: true,
    },
    {
      name: "Monsters Within Event",
      available: 3,
      helpText: "Total number of Apex Packs received out of the 3 available",
      bgColor: COLORS.LTM.MONSTERS_WITHIN,
      darkBadge: true,
    },
  ], // 10
  null, // 11
  [
    {
      name: "3rd Anniversary Event",
      available: 10,
      helpText: "Total number of Apex Packs received out of the 10 available",
      bgColor: "#646302",
      darkBadge: true,
    },
  ], // 12
  null, // 13
]);

export const LEGENDS = Object.freeze({
  ASH: "Ash",
  BANGALORE: "Bangalore",
  BLOODHOUND: "Bloodhound",
  CAUSTIC: "Caustic",
  CRYPTO: "Crypto",
  FUSE: "Fuse",
  GIBRALTAR: "Gibraltar",
  HORIZON: "Horizon",
  LIFELINE: "Lifeline",
  LOBA: "Loba",
  MIRAGE: "Mirage",
  OCTANE: "Octane",
  PATHFINDER: "Pathfinder",
  RAMPART: "Rampart",
  REVENANT: "Revenant",
  SEER: "Seer",
  VALKYRIE: "Valkyrie",
  WATTSON: "Wattson",
  WRAITH: "Wraith",
});

export const HEIRLOOM_ORDER = Object.freeze([
  LEGENDS.WRAITH,
  LEGENDS.BLOODHOUND,
  LEGENDS.LIFELINE,
  LEGENDS.PATHFINDER,
  LEGENDS.OCTANE,
  LEGENDS.MIRAGE,
  LEGENDS.CAUSTIC,
  LEGENDS.GIBRALTAR,
  LEGENDS.BANGALORE,
  LEGENDS.REVENANT,
  LEGENDS.RAMPART,
  LEGENDS.WATTSON,
  LEGENDS.CRYPTO,
]);

export const HEIRLOOMS = Object.freeze({
  [LEGENDS.WRAITH]: "Kunai",
  [LEGENDS.BLOODHOUND]: "Raven's Bite",
  [LEGENDS.LIFELINE]: "Shock Sticks",
  [LEGENDS.PATHFINDER]: "Boxing Gloves",
  [LEGENDS.OCTANE]: "Butterfly Knife",
  [LEGENDS.MIRAGE]: "Too Much Witt",
  [LEGENDS.CAUSTIC]: "Death Hammer",
  [LEGENDS.GIBRALTAR]: "War Club",
  [LEGENDS.BANGALORE]: "Cold Steel",
  [LEGENDS.REVENANT]: "Dead Man's Curve",
  [LEGENDS.RAMPART]: "Problem Solver",
  [LEGENDS.WATTSON]: "Energy Reader",
  [LEGENDS.CRYPTO]: "Biwon Blade",
});

export const PRESTIGE_SKINS_ORDER = Object.freeze([
  LEGENDS.BLOODHOUND,
  LEGENDS.BANGALORE,
]);
export const PRESTIGE_SKINS = Object.freeze({
  [LEGENDS.BLOODHOUND]: "Apex Hunter",
  [LEGENDS.BANGALORE]: "Apex Commander",
});
